export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rules.vue?vue&type=template&id=7cf98572"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/basement/rules.vue?vue&type=template&id=7cf98572
// module id = iex5
// module chunks = 0